import APIConnector from "../lib/APIConnector";
import Settings from "../base/Settings";
import FirebaseConnector from "../lib/FirebaseConnector";
const apiConnector = new APIConnector({ timeout: 30000 });
const apiConnectorLarge = new APIConnector({ timeout: 120000 });
const firebaseConnector = new FirebaseConnector({ timeout: 30000 });

export default class UserConfig {
  static get endpoint() {
    return Settings.SERVICE_DOMAIN;
  }
  static get endpoint2() {
    return Settings.SERVICE_DOMAIN_V2;
  }
  static get endpointUsers() {
    return `${UserConfig.endpoint}/users`;
  }

  static get endpointLoyaly() {
    return `${UserConfig.endpoint}/loyaly`;
  }
  static get transferPointEndpoint() {
    return `${UserConfig.endpointLoyaly}/recharge-points`;
  }
  static get endpointUsersByReg() {
    return `${UserConfig.endpointUsers}/reg`;
  }
  static get endpointUsersByEmailOrDU() {
    return `${UserConfig.endpointUsers}/usersByEmailOrDU`;
  }
  static get endpointUserById() {
    return `${UserConfig.endpointUsers}/userById`;
  }
  static get endpointUsersFromStorage() {
    return `${UserConfig.endpoint2}/users/usersFromStorage`;
  }
  static get endpointUpdateUser() {
    return `${UserConfig.endpointUsers}/updateUser`;
  }
  static get endpointUpdateRoles() {
    return `${UserConfig.endpointUsers}/updateRoles`;
  }
  static get endpointUpdateStatus() {
    return `${UserConfig.endpointUsers}/updateStatus`;
  }
  static get endpointUpdateVerification() {
    return `${UserConfig.endpointUsers}/updateVerification`;
  }
  static get endpointDeleteUser() {
    return `${UserConfig.endpointUsers}/delete`;
  }
  static get endpointAddTagToUser() {
    return `${UserConfig.endpointUsers}/add-tags`;
  }
  static get endpointSendNotification() {
    return `${UserConfig.endpointUsers}/sendNotification`;
  }
  static get endpointExportUsers(){
    return `${UserConfig.endpointUsers}/export`;
  }

  static get endpointMovementsLoyalty() {
    return `${UserConfig.endpoint}/loyaly/user`;
  }
  static get APIConnector() {
    return apiConnector;
  }
  static get APIConnectorLarge() {
    return apiConnectorLarge;
  }

  static get FirebaseConnector() {
    return firebaseConnector;
  }
}




// WEBPACK FOOTER //
// ./src/provider/user/UserConfig.js